<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]" class="dashboard">
      <div id="content-overlay" />

      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
      class="topbar"
      />

      <div id="sidebar" :class="{'sidebar-campaign-detail' : ['edit-campaign','create-campaign','rewardmanager'].includes($route.name)}">
        <ul class="side-menu" :class="{'side-menu-campaign-detail': ['edit-campaign','create-campaign','rewardmanager'].includes($route.name)}">
          <a href="/campaigns"><li v-if="userCapable" class="side-menu-item" :class="{ active: activePage === 'campaigns' }">
            <i class="fas fa-award"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Campaigns</span>
          </li></a>
          <a  href="/rewardmanager"><li v-if="userCapable" class="side-menu-item" :class="{ active: activePage === 'rewardmanager' }">
            <i class="fas fa-medal"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Reward Manager</span>
          </li></a>
          <a href="/datahub"><li v-if="userCapable"  class="side-menu-item" :class="{ active: activePage === 'datahub' }">
           <i class="fas fa-chart-bar"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Data Hub</span>
          </li></a>
          <a  href="/producteditor"><li v-if="activeUserInfo.permissionLevel === 2048" class="side-menu-item" :class="{ active: activePage === 'producteditor' }">
           <i class="fas fa-box"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Product Editor</span>
          </li></a>
          <a href="/taskmanager"><li v-if="activeUserInfo.permissionLevel === 2048" class="side-menu-item" :class="{ active: activePage === 'taskmanager' }">
            <i class="fas fa-tasks"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Task Manager</span>
          </li></a>
          <a href="/users"><li v-if="activeUserInfo.permissionLevel === 2048" class="side-menu-item" :class="{ active: activePage === 'users' }">
            <i class="fas fa-user"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Users</span>
          </li></a>
          <a href="/connections"><li v-if="userCapable" class="side-menu-item" :class="{ active: activePage === 'connections' }">
            <i class="fas fa-project-diagram"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">Connections</span>
          </li></a>
          <a href="/howtouse"><li class="side-menu-item" :class="{ active: activePage === 'howtouse' }">
            <i class="fas fa-question-circle"></i> <span v-if="!['edit-campaign','create-campaign','rewardmanager'].includes($route.name)">How To Use</span>
          </li></a>
        </ul>
      </div>

      <div class="content-wrapper" id="mainarea" :class="{'mainarea-campaign-detail' : ['edit-campaign','create-campaign','rewardmanager'].includes($route.name)}">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown>

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>

  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu
  },
  mounted () {
    console.log('page', this.activePage)
  },
  data () {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      image_to_show: '',
      image_frame_to_show: '',
      year: new Date().getFullYear(),
      activePage: this.$router.currentRoute.name
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    },
    '$store.state.eventImage' (val) {
      this.image_to_show = val
      this.showCamFrame = val.concat('?').concat(Math.random())
      console.log('event image', this.showCamFrame)
    },
    '$store.state.eventImagePreview' (val) {
      this.image_frame_to_show = val
    }
  },
  computed: {
    userCapable () {
      let result = true
      try {
        this.activeUserInfo.subscriptions.map(sub => {
          if (sub.plan.product.id === 'prod_LxaiP3NvLRaWld') {
            result = true
          }
        })
      } catch (e) {
        console.log(e)
      }
      return result
    },
    getVideoFrame () {
      return this.image_to_show
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    getImageFrame () {
      return this.image_frame_to_show
    },
    showPopup () { return this.$store.state.showPopup },
    showImagePopup () { return this.$store.state.showImagePopup },
    eventImage () { return this.$store.state.eventImage },
    eventImagePreview () { return this.$store.state.eventImagePreview },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
  }
}

</script>

<style lang="scss">
  .side-menu-item {
    color: #20CFFF;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.32px;
    border-bottom: none;
  }
  .side-menu-item:hover {
    color: #fff;
  }
  .sidebar-campaign-detail {
    width: 110px !important;
  }
  .side-menu-campaign-detail {
    margin: 0 14px !important;
  }
  .sub-sidebar {
    background-color: #013A5A !important;
    width: 217px !important;
  }
  .mainarea-campaign-detail {
    width: calc(100% - 110px) !important;
  }
  .sub-sidebar a li {
    font-size: 11px;
    width: 217px;
    padding: 22px 20px !important;
    float: left
  }
  .sub-sidebar > .side-menu > a > li:hover {
    background-color: #00527A;
  }

</style>

